import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, FieldGroup, Page, TextField } from '../../../components';
import { useStore } from '../../../store';
import { onSuccess } from '../../../utils/errors';

export default observer(function MoveCustomerKeysPage() {
  const { pulseKeyStore } = useStore();
  const [oldCustomerEmail, setOldCustomerEmail] = useState('');
  const [newCustomerEmail, setNewCustomerEmail] = useState('');

  async function onClick() {
    await pulseKeyStore.moveCustomerKeys({
      oldCustomerEmail,
      newCustomerEmail,
    });
    onSuccess(`Keys from ${oldCustomerEmail} are moved to ${newCustomerEmail}`);
  }

  return (
    <Page navigation={{ title: 'Move customer keys', icon: 'people-arrows' }}>
      <FieldGroup sx={{ gap: 3, mb: 2 }}>
        <TextField
          label="Old customer email"
          onChange={(e) => setOldCustomerEmail(e.target.value)}
          sx={{ width: 240 }}
          value={oldCustomerEmail}
        />
        →
        <TextField
          label="New customer email"
          onChange={(e) => setNewCustomerEmail(e.target.value)}
          sx={{ width: 240 }}
          value={newCustomerEmail}
        />
      </FieldGroup>

      <Button
        disabled={!oldCustomerEmail || !newCustomerEmail}
        icon="arrow-right"
        onClick={onClick}
        size="small"
        type="primary"
      >
        Move all redeemed Pulse Keys
      </Button>
    </Page>
  );
});
